import React from 'react';
import {
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper, Box
} from '@mui/material';
import {makeStyles} from "@material-ui/core/styles";
import {useTranslation} from "react-i18next";

const useStyles = makeStyles((theme) => ({
    root: {},
    title: {
        fontSize: '24px',
        fontStyle: 'Roboto-Regular',
        textAlign: 'center',
        color: '#981B49',
        marginBottom: '20px',
    },
}));

const StatisticsTable = ({ legendData }) => {
    const { t } = useTranslation();

    return (
        <Box style={{ marginTop: '30px', width:'288px'}}>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell><strong>{t('STATISTICS.STATISTIC_INDICATOR')}</strong></TableCell>
                            <TableCell><strong>{t('STATISTICS.SYSTEM_DATA_PERIOD')}</strong></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {legendData.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell
                                >
                                    {row.statistics_indicator_label}
                                </TableCell>
                                <TableCell >{row.data_min_period} - {row.data_max_period}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}

export default StatisticsTable;
